import {activityLogRoute, adminRoute} from '../../routes';

// We need a way to know that we're on one of the
// security posture pages.  So far, that's simple -
// anything but the Activity Log.
export const isSecurityPostureRoute = (path: string) => {
  return (
    path !== activityLogRoute &&
    !path.includes(adminRoute)
  );
};
